// testimonial slider
const swiperTestimonial = new Swiper(".testimonial__slider", {
  loop: true,
  spaceBetween: 1,
  slidesPerView: "auto",
  speed: 800,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".testimonial__slider-next",
    prevEl: ".testimonial__slider-prev",
  },
  breakpoints: {
    768: {
      spaceBetween: 32,
      slidesPerView: "auto",
    },
    992: {
      spaceBetween: 40,
      slidesPerView: 3,
    },
  },
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
});

const swiperTestimonialCategories = new Swiper(".testimonial__slider__categories", {
  loop: false,
  spaceBetween: 1,
  slidesPerView: "auto",
  speed: 800,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".testimonial__slider-next",
    prevEl: ".testimonial__slider-prev",
  },
  breakpoints: {
    768: {
      spaceBetween: 32,
      slidesPerView: "auto",
    },
    992: {
      spaceBetween: 40,
      slidesPerView: 3,
    },
  },
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
});

const testimonialButton = document.querySelector('.testimonial__tag__button');

if (testimonialButton) {
    testimonialButton.addEventListener('click', () => {
        document.querySelector('.testimonial__tag').classList.toggle('active');
    });
}

const tagBlock = document.querySelector('.testimonial__tag');
  if (tagBlock) {

    const buttons = tagBlock.querySelectorAll('[data-button]');
    const slides = document.querySelectorAll('.testimonial__slider__categories .swiper-slide');

    buttons.forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();

      buttons.forEach(btn => btn.classList.remove('active'));

      button.classList.add('active');

      const filterValue = button.getAttribute('data-button');
      const swiperEl = document.querySelector('.testimonial__slider__categories.swiper');
      const swiper = swiperEl?.swiper;

      slides.forEach(slide => {
          const slideValue = slide.getAttribute('data-slide');
          if (filterValue === 'all' || slideValue === filterValue) {
              slide.style.display = '';
          } else {
              slide.style.display = 'none';
          }
      });

      if (swiper && typeof swiper.update === 'function') {
        swiper.update();

        if (filterValue === 'all') {
          swiper.slideTo(0);
        } else {
          swiper.slideTo(0);
        }
      }
    });
  });
}


function checkLinesAndAddClass(block) {
    const textElement = block.querySelector('.testimonial__slide__text');
    if (!textElement) return;
    
    const tempText = textElement.cloneNode(true);
    tempText.style.position = 'absolute';
    tempText.style.opacity = '0';
    tempText.style.visibility = 'hidden';
    tempText.style.width = textElement.offsetWidth + 'px';
    tempText.style.maxHeight = 'none'; 
    tempText.style.display = 'block';
    
    tempText.style.webkitLineClamp = 'none';
    tempText.style.overflow = 'visible';
    
    document.body.appendChild(tempText);
    
    const textHeight = tempText.offsetHeight;
    
    const firstParagraph = tempText.querySelector('p');
    const styles = firstParagraph ? window.getComputedStyle(firstParagraph) : window.getComputedStyle(tempText);
    const fontSize = parseFloat(styles.fontSize);
    const lineHeightValue = styles.lineHeight;
    const lineHeight = lineHeightValue === 'normal' ? fontSize * 1.4 : parseFloat(lineHeightValue);
    
    tempText.remove();
    
    const estimatedLines = Math.ceil(textHeight / lineHeight);
    
    const isMobile = window.innerWidth <= 768;
    const maxLines = isMobile ? 9 : 8;
    
    // console.log(`Высота: ${textHeight}px, высота строки: ${lineHeight}px, строк: ${estimatedLines}, лимит: ${maxLines}`);
    
    block.classList.toggle('handle', estimatedLines > maxLines);
    
    return estimatedLines;
}

const testimonialSlides = document.querySelectorAll('.testimonial__slide');

function initLineCheck() {
    testimonialSlides.forEach(checkLinesAndAddClass);
}

document.addEventListener('DOMContentLoaded', initLineCheck);
window.addEventListener('load', initLineCheck);
window.addEventListener('resize', () => {
    clearTimeout(window.resizeTimer);
    window.resizeTimer = setTimeout(initLineCheck, 150);
});

if (typeof Swiper !== 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
        const swiper = document.querySelector('.testimonial__slider')?.swiper;
        if (swiper) {
            swiper.on('slideChangeTransitionEnd', initLineCheck);
        }
    });
}


document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.testimonial__slide.handle').forEach(slide => {
    slide.addEventListener('click', function(e) {
      if (e.target.closest('.testimonial__slide__popup__close')) return;
      const existingPopup = document.querySelector('.testimonial__slide__popup--global');
      if (existingPopup) {
        existingPopup.remove();
      }
      createModalPopup(this);
      document.querySelector('body').classList.add('open-testimonial-popup');
    });
  });
  

  document.addEventListener('click', function(e) {
    if (e.target.closest('.testimonial__slide__popup__close')) {
      const popup = e.target.closest('.testimonial__slide__popup--global');
      if (popup) popup.remove();
      document.querySelector('body').classList.remove('open-testimonial-popup');
    }
    if (e.target.classList.contains('testimonial__slide__popup--global')) {
      e.target.remove();
      document.querySelector('body').classList.remove('open-testimonial-popup');
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const popup = document.querySelector('.testimonial__slide__popup--global');
      if (popup) popup.remove();
      document.querySelector('body').classList.remove('open-testimonial-popup');
    }
  });
});


function createModalPopup(slideElement) {
  const slideContent = slideElement.cloneNode(true);
  
  const existingPopupInClone = slideContent.querySelector('.testimonial__slide__popup');
  if (existingPopupInClone) {
    existingPopupInClone.remove();
  }
  
  const modalHTML = `
    <div class="testimonial__slide__popup testimonial__slide__popup--global">
      <button class="testimonial__slide__popup__close">
        <img src="img/icons/close-white.svg" alt="Закрыть">
      </button>
      <div class="testimonial__slide__popup__content">
        ${slideContent.innerHTML}
      </div>
    </div>
  `;
  
  document.body.insertAdjacentHTML('beforeend', modalHTML);

}